import Vue from 'vue'

Vue.filter('cutString', function(value, count) {
    if (value) {
        return value.substring(0, count) + '...'
    }
})
